import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";

import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { Dropdown } from 'primereact/dropdown';
import { showToast } from "../ToastManager";
import { MultiSelect } from 'primereact/multiselect';

import Utils from "../../utilities/Utils";

import AgendaService from "../../service/AgendaService";
import AgendamentoService from "../../service/AgendamentoService";
import PrestadorService from "../../service/PrestadorService";
import PrestadorTipoAgendamentoService from "../../service/PrestadorTipoAgendamentoService";
import EmpresaService from '../../service/EmpresaService';
import RoleService from '../../service/RoleService';
import UsuarioService from '../../service/UsuarioService';

const usuarioService = new UsuarioService();
const prestadorService = new PrestadorService(); // Create an instance of LojaService
const prestadorTipoAgendamentoService = new PrestadorTipoAgendamentoService(); // Create an instance of LojaService
const agendamentoService = new AgendamentoService();
const agendaService = new AgendaService();
const empresaService = new EmpresaService(); // Create an instance of EmpresaService

const CadastrarAgendaPrestador = () => {
    const iss = localStorage.getItem('iss');
    const history = useHistory();
    let idPrestador = JSON.parse(localStorage.getItem('idPrestador'));

    let agendaNovo = {
        hora_inicio: '',
        hora_fim: '',
        hora_inicio_almoco: '',
        hora_fim_almoco: '',
        intervalo_atendimento: '',
        dia_semana: '',
        status: '',
        prestador_tipo_agendamento_id: null,
        prestadorTipoAgendamento: null
    };

    const [agenda, setAgenda] = useState(agendaNovo);

    const [empresa, setEmpresa] = useState([]);
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);

    const [tipoAgendamento, setTipoAgendamento] = useState();
    const [selectTipoAgendamento, setSelectTipoAgendamento] = useState([]);

    const [prestador, setPrestador] = useState(null);
    const [selectedPrestador, setSelectedPrestador] = useState([]);

    const [prestadorTipoAgendamento, setPrestadorTipoAgendamento] = useState([]);
    const [prestadorTipoAgendamentoId, setPrestadorTipoAgendamentoId] = useState([]);

    const [submitted, setSubmitted] = useState(false);

    const [loading, setLoading] = useState(false);
    const [calendarValue, setCalendarValue] = useState(null);
    const [diaSemana, setDiaSemana] = useState(null);

    const [status, setStatus] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(null);

    const [disable, setDisabled] = useState(true);

    // Adicione um estado para controlar se os dados já foram carregados
    const [dataLoaded, setDataLoaded] = useState(false);

    const { id } = useParams();

    const diasDaSemana = [
        { name: 'Domingo' },
        { name: 'Segunda' },
        { name: 'Terça' },
        { name: 'Quarta' },
        { name: 'Quinta' },
        { name: 'Sexta' },
        { name: 'Sábado' }
    ];

    const statusAgenda = ['ATIVO', 'INATIVO', 'BLOQUEADO']

    const calcularDiaDaSemana = (data) => {
        const diaSemanaNome = diasDaSemana[data.getDay()];

        setCalendarValue(data)
        setDiaSemana(diaSemanaNome);
    };

    const getTipoServico = useCallback(async (company) => {
        setDisabled(true);
        try {
            const body = {};
            body.company_id = company;
            const response = await prestadorTipoAgendamentoService.listPrestadoresTipoAgendamento(iss, body);
            const prestadorData = response.data;
            setPrestadorTipoAgendamento(prestadorData);
            const updatedItems = prestadorData.map(({ tiposAgendamento, ...rest }) => rest);
            setPrestador(updatedItems);
            if (prestadorData.length === 1) {
                setSelectedPrestador(updatedItems[0])
                const prestadores = prestadorData.find(p => p.id === updatedItems[0].id);
                if (prestadores) {
                    const updatedTipos = prestadores.tiposAgendamento.map(({ ativo, ...rest }) => rest);
                    setTipoAgendamento(updatedTipos);
                    if (updatedTipos.length === 1) {
                        setSelectTipoAgendamento(updatedTipos[0]);
                        setPrestadorTipoAgendamentoId(updatedTipos[0].id);
                    }
                }
            }
            return true;
        } catch (e) {
            return false;
        }
    }, [iss]);

    const getServicoPrestador = useCallback((idPrestador) => {
        try {
            if (!prestadorTipoAgendamento) {
                console.log("prestadorTipoAgendamento ainda não está definido");
                return false; // Indica que não foi possível processar
            }

            const prestadores = prestadorTipoAgendamento.find(p => p.id === idPrestador);
            if (prestadores) {
                const updatedItems = prestadores.tiposAgendamento.map(({ ativo, ...rest }) => rest);
                setTipoAgendamento(updatedItems);
            } else {
                console.log("Prestador não encontrado:", idPrestador);
            }
        } catch (e) {
            console.log(e);
        }
    }, [prestadorTipoAgendamento]);

    const initEmpresa = useCallback(async () => {
        setLoading(true);

        try {
            const data = await empresaService.listAllEmpresas(iss);
            const updatedItems = data.data.rows.map(({ categoria_id, categoriaCompany, cnpj, razaoSocial, telefone, endereco, cidade, estado, cep, excluido, ativo, url, createdAt, updatedAt, ...rest }) => rest);
            setEmpresa(updatedItems);
            if (data.data.count === 1) {
                setSelectedEmpresa(updatedItems[0])
                getTipoServico(data.data.rows[0].id)
                setDisabled(false);
            }
        } catch (error) {
            console.error("Erro ao carregar empresas:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar empresas' });
        } finally {
            setLoading(false);
        }
    }, [getTipoServico, iss]);

    /* const initEmpresa = useCallback(() => {
        if (RoleService.isAdmin()) {
            empresaService.listAllEmpresa(iss).then(data => {
                const updatedItems = data.data.rows.map(({ categoria_id, categoriaCompany, cnpj, razaoSocial, telefone, endereco, cidade, estado, cep, excluido, ativo, createdAt, updatedAt, ...rest }) => rest);
                setEmpresa(updatedItems);
            });
        } else {
            var id = usuarioService.getEmpresaLocalData()
            empresaService.getEmpresa(iss, id).then(data => {
                const updatedItems = data.data.rows.map(({ categoria_id, categoriaCompany, cnpj, razaoSocial, telefone, endereco, cidade, estado, cep, excluido, ativo, createdAt, updatedAt, ...rest }) => rest);
                setEmpresa(updatedItems);
                setSelectedEmpresa(updatedItems[0])
                getTipoServico(id)
                setDisabled(false);
            });
        }
    }, [getTipoServico, iss]); */

    // Efeito para carregar empresas
    useEffect(() => {
        initEmpresa();
    }, [initEmpresa]);

    // Efeito para carregar dados da agenda quando id existir e empresa estiver carregada
    useEffect(() => {
        const loadAgendaData = async () => {
            if (id && !dataLoaded && empresa.length > 0) {
                try {
                    setLoading(true);
                    const data = await agendaService.getAgendaPrestador(iss, id);
                    const agendaNovo = data.data.rows[0];
                    const companyId = agendaNovo.prestadorTipoAgendamento.tipoAgendamento.companies.id;
                    const prestadorId = agendaNovo.prestadorTipoAgendamento.prestador.id;

                    // Aguarde a conclusão de getTipoServico
                    const success = await getTipoServico(companyId);

                    if (success) {
                        // Agora que getTipoServico foi concluído, chame getServicoPrestador
                        getServicoPrestador(prestadorId);
                    }

                    // Continue com o restante do código
                    const prestador = {
                        id: agendaNovo.prestadorTipoAgendamento.prestador.id,
                        nome: agendaNovo.prestadorTipoAgendamento.prestador.nome
                    };

                    const servico = {
                        id: agendaNovo.prestadorTipoAgendamento.id,
                        tipoAgendamento: {
                            id: agendaNovo.prestadorTipoAgendamento.tipoAgendamento.id,
                            nome: agendaNovo.prestadorTipoAgendamento.tipoAgendamento.nome
                        }
                    };

                    const diasDaSemana = [{ name: agendaNovo.dia_semana }];
                    setDiaSemana(diasDaSemana);
                    setStatus(agendaNovo.status);

                    // Encontre a empresa correspondente pelo ID
                    const empresaEncontrada = empresa.find(e => e.id === companyId);
                    if (empresaEncontrada) {
                        setSelectedEmpresa(empresaEncontrada);
                    }

                    setSelectedStatus(agendaNovo.status);
                    setSelectedPrestador(prestador);
                    setSelectTipoAgendamento(servico);
                    setPrestadorTipoAgendamentoId(agendaNovo.prestador_tipo_agendamento_id);
                    setDisabled(false);

                    setTimeout(() => {
                        setAgenda({
                            ...agendaNovo,
                            hora_inicio: (agendaNovo.hora_inicio || '').slice(0, 5),
                            hora_fim: (agendaNovo.hora_fim || '').slice(0, 5),
                            hora_inicio_almoco: (agendaNovo.hora_inicio_almoco || '').slice(0, 5),
                            hora_fim_almoco: (agendaNovo.hora_fim_almoco || '').slice(0, 5)
                        });
                    }, 200);

                    // Marque os dados como carregados para evitar recarregamento
                    setDataLoaded(true);
                } catch (error) {
                    console.error("Erro ao carregar dados:", error);
                } finally {
                    setLoading(false);
                }
            }
        };

        loadAgendaData();
    }, [id, getTipoServico, getServicoPrestador, iss, empresa, dataLoaded]);

    // Função para lidar com a mudança de empresa
    const handleEmpresaChange = (e) => {
        setSelectedEmpresa(e.value);
        if (e.value && e.value.id) {
            getTipoServico(e.value.id);
            setSelectedPrestador(null);
            setSelectTipoAgendamento(null);
        }
    };

    // Função para lidar com a mudança de prestador
    const handlePrestadorChange = (e) => {
        setSelectedPrestador(e.value);
        if (e.value && e.value) {
            getServicoPrestador(e.value.id);
            setSelectTipoAgendamento(null);
        }
    };

    // Função para lidar com a mudança de tipo de agendamento
    const handleTipoAgendamentoChange = (e) => {
        setSelectTipoAgendamento(e.value);
        setPrestadorTipoAgendamentoId(e.value.id)
        // Aqui você pode adicionar lógica adicional se necessário
    };

    // Função para lidar com a mudança de dia da semana
    const handleDiaSemanaChange = (e) => {
        setDiaSemana(e.value);
        // Atualizar o estado da agenda
        setAgenda(prevAgenda => ({
            ...prevAgenda,
            dia_semana: e.value.name
        }));
    };

    // Função para lidar com a mudança de status
    const handleStatusChange = (e) => {
        setSelectedStatus(e.value);
        // Atualizar o estado da agenda
        setAgenda(prevAgenda => ({
            ...prevAgenda,
            status: e.value
        }));
    };

    // Função para lidar com mudanças nos campos de texto
    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _agenda = { ...agenda };
        _agenda[`${name}`] = val;
        setAgenda(_agenda);
    };

    // Função para salvar a agenda
    const saveAgenda = () => {
        setSubmitted(true);

        const inicioAlmoco = agenda.hora_inicio_almoco || '';
        const fimAlmoco = agenda.hora_fim_almoco || '';
        const horarioValido = /^([01]\d|2[0-3]):[0-5]\d$/;

        if (inicioAlmoco || fimAlmoco) {
            let erroAlmoco = '';
            if (!horarioValido.test(inicioAlmoco) || !horarioValido.test(fimAlmoco)) {
                erroAlmoco = 'Informe início e fim do almoço com horários válidos (HH:MM).';
            } else if (inicioAlmoco >= fimAlmoco) {
                erroAlmoco = 'O início do almoço deve ser anterior ao fim.';
            } else if (inicioAlmoco < agenda.hora_inicio || fimAlmoco > agenda.hora_fim) {
                erroAlmoco = 'O horário de almoço deve estar dentro do expediente.';
            }
            if (erroAlmoco) {
                showToast({ severity: 'warn', summary: 'Atenção', detail: erroAlmoco });
                return;
            }
        }

        // Validar campos obrigatórios
        if (agenda.hora_inicio && agenda.hora_fim && agenda.intervalo_atendimento &&
            diaSemana && selectedStatus && selectedPrestador && selectTipoAgendamento) {

            setLoading(true);

            // Preparar objeto para salvar
            let agendaToSave = {
                hora_inicio: agenda.hora_inicio,
                hora_fim: agenda.hora_fim,
                hora_inicio_almoco: inicioAlmoco || null,
                hora_fim_almoco: fimAlmoco || null,
                intervalo_atendimento: agenda.intervalo_atendimento,
                dias_semana: diaSemana,
                status: selectedStatus,
                prestador_tipo_agendamento_id: prestadorTipoAgendamentoId // Certifique-se de que este é o ID correto
            };

            if (id) {
                // Atualizar agenda existente
                agendaService.putAgendaPrestador(iss, agendaToSave, id)
                    .then(response => {
                        showToast('success', 'Sucesso', 'Agenda atualizada com sucesso');
                        history.push('/agenda/listar');
                    })
                    .catch(error => {
                        console.error("Erro ao atualizar agenda:", error);
                        showToast('error', 'Erro', 'Erro ao atualizar agenda');
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            } else {
                // Criar nova agenda
                agendaService.postAgendaPrestador(iss, agendaToSave)
                    .then(response => {
                        showToast('success', 'Sucesso', 'Agenda criada com sucesso');
                        history.push('/agenda/listar');
                    })
                    .catch(error => {
                        console.error("Erro ao criar agenda:", error);
                        showToast('error', 'Erro', 'Erro ao criar agenda');
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        } else {
            showToast('warn', 'Atenção', 'Preencha todos os campos obrigatórios');
        }
    };

    // Função para cancelar e voltar
    const cancelar = () => {
        history.push('/agenda/listar');
    };

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>{id ? 'Editar' : 'Cadastrar'} Agenda</h5>

                    <div className="p-fluid formgrid grid">
                        {/* Empresa */}
                        <div className="field col-12 md:col-4">
                            <label htmlFor="empresa">Empresa</label>
                            <Dropdown
                                id="empresa"
                                value={selectedEmpresa}
                                options={empresa}
                                onChange={handleEmpresaChange}
                                optionLabel="name"
                                placeholder="Selecione a Empresa"
                                disabled={!RoleService.isAdmin() || loading}
                                className={classNames({ 'p-invalid': submitted && !selectedEmpresa })}
                            />
                            {submitted && !selectedEmpresa && <small className="p-error">Empresa é obrigatória.</small>}
                        </div>

                        {/* Prestador */}
                        <div className="field col-12 md:col-4">
                            <label htmlFor="prestador">Prestador</label>
                            <Dropdown
                                id="prestador"
                                value={selectedPrestador}
                                options={prestador}
                                dataKey="id"
                                onChange={handlePrestadorChange}
                                optionLabel="nome"
                                placeholder="Selecione o Prestador"
                                disabled={!selectedEmpresa || loading}
                                className={classNames({ 'p-invalid': submitted && !selectedPrestador })}
                            />
                            {submitted && !selectedPrestador && <small className="p-error">Prestador é obrigatório.</small>}
                        </div>

                        {/* Tipo de Agendamento */}
                        <div className="field col-12 md:col-4">
                            <label htmlFor="tipoAgendamento">Tipo de Agendamento</label>
                            <Dropdown
                                id="tipoAgendamento"
                                value={selectTipoAgendamento}
                                options={tipoAgendamento}
                                onChange={handleTipoAgendamentoChange}
                                optionLabel="tipoAgendamento.nome"
                                placeholder="Selecione o Tipo de Agendamento"
                                disabled={!selectedPrestador || loading}
                                className={classNames({ 'p-invalid': submitted && !selectTipoAgendamento })}
                            />
                            {submitted && !selectTipoAgendamento && <small className="p-error">Tipo de Agendamento é obrigatório.</small>}
                        </div>

                        {/* Hora Início */}
                        <div className="field col-12 md:col-1">
                            <label htmlFor="horaInicio">Hora Início</label>
                            <InputMask
                                id="horaInicio"
                                value={agenda.hora_inicio}
                                onChange={(e) => onInputChange(e, 'hora_inicio')}
                                mask="99:99"
                                placeholder="HH:MM"
                                disabled={loading}
                                className={classNames({ 'p-invalid': submitted && !agenda.hora_inicio })}
                            />
                            {submitted && !agenda.hora_inicio && <small className="p-error">Hora Início é obrigatória.</small>}
                        </div>

                        {/* Hora Fim */}
                        <div className="field col-12 md:col-1">
                            <label htmlFor="horaFim">Hora Fim</label>
                            <InputMask
                                id="horaFim"
                                value={agenda.hora_fim}
                                onChange={(e) => onInputChange(e, 'hora_fim')}
                                mask="99:99"
                                placeholder="HH:MM"
                                disabled={loading}
                                className={classNames({ 'p-invalid': submitted && !agenda.hora_fim })}
                            />
                            {submitted && !agenda.hora_fim && <small className="p-error">Hora Fim é obrigatória.</small>}
                        </div>

                        <div className="field col-12 md:col-2">
                            <div className="formgrid grid">
                                <div className="field col-12 sm:col-6 mb-0">
                                    <label htmlFor="horaInicioAlmoco">Início do almoço</label>
                                    <InputMask
                                        id="horaInicioAlmoco"
                                        value={agenda.hora_inicio_almoco}
                                        onChange={(e) => onInputChange(e, 'hora_inicio_almoco')}
                                        mask="99:99"
                                        placeholder="HH:MM"
                                        disabled={loading}
                                        aria-describedby="horarioAlmocoAjuda"
                                    />
                                </div>
        
                                <div className="field col-12 sm:col-6 mb-0">
                                    <label htmlFor="horaFimAlmoco">Fim do almoço</label>
                                    <InputMask
                                        id="horaFimAlmoco"
                                        value={agenda.hora_fim_almoco}
                                        onChange={(e) => onInputChange(e, 'hora_fim_almoco')}
                                        mask="99:99"
                                        placeholder="HH:MM"
                                        disabled={loading}
                                        aria-describedby="horarioAlmocoAjuda"
                                    />
                                </div>
                            </div>
                            <small id="horarioAlmocoAjuda" className="block mt-1">Opcional. Preencha início e fim ou deixe ambos vazios.</small>
                        </div>

                        {/* Intervalo de Atendimento */}
                        <div className="field col-12 md:col-2">
                            <label htmlFor="intervaloAtendimento">Intervalo (min)</label>
                            <InputText
                                id="intervaloAtendimento"
                                value={agenda.intervalo_atendimento}
                                onChange={(e) => onInputChange(e, 'intervalo_atendimento')}
                                placeholder="Ex: 30"
                                keyfilter="pint" // Apenas números inteiros positivos
                                disabled={loading}
                                className={classNames({ 'p-invalid': submitted && !agenda.intervalo_atendimento })}
                            />
                            {submitted && !agenda.intervalo_atendimento && <small className="p-error">Intervalo é obrigatório.</small>}
                        </div>

                        {/* Dia da Semana */}
                        <div className="field col-12 md:col-4">
                            <label htmlFor="diaSemana">Dia da Semana</label>
                            <MultiSelect
                                id="diaSemana"
                                value={diaSemana}
                                options={diasDaSemana}
                                onChange={(e) => setDiaSemana(e.value)}
                                optionLabel="name"
                                placeholder="Selecione o Dia"
                                disabled={loading}
                                className={classNames({ 'p-invalid': submitted && (!diaSemana || diaSemana.length === 0) })}
                            />
                            {submitted && (!diaSemana || diaSemana.length === 0) && <small className="p-error">Dia da Semana é obrigatório.</small>}
                        </div>

                        {/* Status */}
                        <div className="field col-12 md:col-2">
                            <label htmlFor="status">Status</label>
                            <Dropdown
                                id="status"
                                value={selectedStatus}
                                options={statusAgenda}
                                onChange={handleStatusChange}
                                placeholder="Selecione o Status"
                                disabled={loading}
                                className={classNames({ 'p-invalid': submitted && !selectedStatus })}
                            />
                            {submitted && !selectedStatus && <small className="p-error">Status é obrigatório.</small>}
                        </div>
                    </div>

                    {/* Botões de ação */}
                    <div className="flex justify-content-end mt-4">
                        <Button
                            label="Cancelar"
                            icon="pi pi-times"
                            className="p-button-text"
                            onClick={cancelar}
                            disabled={loading}
                        />
                        <Button
                            label="Salvar"
                            icon="pi pi-check"
                            className="p-button-primary"
                            onClick={saveAgenda}
                            loading={loading}
                            disabled={disable}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CadastrarAgendaPrestador;